import { BehaviorSubject, merge, Subject, timer } from 'rxjs';
import { LayerStyle, MapboxLayerType } from './layer.type';
import { LayerGroup } from './layer-group.model';
import { MapSettingsService } from '../components/map-settings/map-settings-service';
import { map, shareReplay } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';

@Injectable()
export class BaseLayer implements OnDestroy {
  private readonly ngUnsubscribe = new Subject<void>();

  public readonly id: string;
  public readonly name: string;
  protected style?: { layerType?: MapboxLayerType; } & LayerStyle | { layerType?: 'html-marker'; sourceType?: 'geojson'; } & LayerStyle;

  protected mapRef: mapboxgl.Map;
  protected readonly isVisibleBS = new BehaviorSubject({
    layerVisible: false
  });
  public readonly isVisible$ = this.isVisibleBS.asObservable();

  protected layerGroup: LayerGroup;

  protected readonly isSelectedBS = new BehaviorSubject(false);
  public readonly isSelected$ = this.isSelectedBS.asObservable();

  protected readonly isLoadedBS = new BehaviorSubject(false);
  public isLoaded$ = merge(
    this.isLoadedBS,
    // Timeout for showing the "loading" state
    timer(60 * 1000).pipe(map(() => true), shareReplay(1))
  );


  constructor(private mapSettingsService: MapSettingsService) {}

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public toggleIsSelected() {
    this.setIsSelected(!this.isSelectedBS.getValue());

    // show group when the first layer within is shown
    if (
      this.getIsSelected() &&
      this.layerGroup &&
      !this.layerGroup.getIsVisible() &&
      this.layerGroup.layers.filter(layer => layer.getIsSelected()).length === 1
    ) {
      this.layerGroup.setVisibility(true);
    }
  }
  public setIsSelected(selected: boolean) {
    this.isSelectedBS.next(selected);
    const isGroupVisible = this.layerGroup?.getIsVisible();
    if (isGroupVisible) {
      this.setVisibility(selected);
    } else {
      this.setVisibility(false);
    }
  }
  public getIsSelected() {
    return this.isSelectedBS.getValue();
  }

  public toggleVisibility() {
    this.setVisibility(!this.isVisibleBS.getValue().layerVisible);
  }
  public setVisibility(isVisible: boolean, forceGroupVisibility = false) {
    if (this.layerGroup && forceGroupVisibility) {
      this.setIsSelected(isVisible);
      this.layerGroup.setVisibility(isVisible);
    } else {
      if (this.mapRef.getLayer(this.id)) {
        this.mapRef.setLayoutProperty(this.id, 'visibility', isVisible ? 'visible' : 'none');
      }
      this.style.visible = isVisible;
      this.isVisibleBS.next({layerVisible: isVisible});
    }
  }
  public getIsVisible() {
    return this.isVisibleBS.getValue().layerVisible;
  }

  public setLayerGroup(group: LayerGroup) {
    this.layerGroup = group;
  }
}
